import React from 'react';
import { renderCard } from './shared/renderers';

export default function CardBlock({ props = {}, theme }) {
  return renderCard(props, theme);
}
